import React from 'react';
import PropTypes from 'prop-types';

import BoxedCustomControl from '../../../../../../../../components/global/BoxedCustomControl';

const propTypes = {
  album: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string,
    removable: PropTypes.bool,
  }).isRequired,
  isSelected: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

const AlbumItem = ({ album, isSelected, onChange }) => {
  return (
    <BoxedCustomControl
      key={album.id}
      label={album.label || album.name}
      type="checkbox"
      id={album.id}
      checked={isSelected}
      boxStyle="outlined"
      disabled={album.permanent}
      onChange={onChange}
      customControlProps={{
        shape: 'squared',
      }}
      className="freemium-event-create-album-item"
    />
  );
};

AlbumItem.propTypes = propTypes;

export default AlbumItem;
